"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteMonitorRuleApi = deleteMonitorRuleApi;
exports.getMonitorRuleDetailApi = getMonitorRuleDetailApi;
exports.getPriceMonitorRuleListApi = getPriceMonitorRuleListApi;
exports.getProductSelectListApi = getProductSelectListApi;
exports.savePriceMonitorRuleApi = savePriceMonitorRuleApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// 价格 - 价格监测 - 监测配置

// ========== 特定商品规则 模块 ==========

/**
 * 获取特定商品规则列表
 * @param params 查询参数
 */
function getPriceMonitorRuleListApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/price/monitor/rule/list',
    method: 'get',
    params: params
  });
}

/**
 * 获取可特定监控的商品列表
 * @param params 查询参数
 */
function getProductSelectListApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/price/monitor/product/select',
    method: 'get',
    params: params
  });
}

/**
 * 添加/编辑特定商品监控规则
 * @param data 提交数据
 */
function savePriceMonitorRuleApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/price/monitor/rule/save',
    method: 'post',
    data: data
  });
}

/**
 * 获取特定商品监控规则详情
 * @param id 商品规则ID
 */
function getMonitorRuleDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/price/monitor/rule/detail/".concat(id),
    method: 'get'
  });
}

/**
 * 删除特定商品监控规则
 * @param id 商品规则ID
 */
function deleteMonitorRuleApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/price/monitor/rule/delete/".concat(id),
    method: 'delete'
  });
}